<template>
  <table summary="" cellpadding="4" cellspacing="0" class="rating" :id="field.name">
    <tbody>
    <tr>
      <th>&nbsp;</th>
      <th style="text-align:center;" v-for="rate in field.values"
          v-show="!isValueHidden(rate.value)">
        <label :for="field.name + '_' + rate.value">{{ rate.label }}</label>
      </th>
      <th>&nbsp;</th>
    </tr>
    <tr style="border-top:1px solid #aaadb0;">
      <td><label>{{ field.minText }}</label></td>
      <td style="text-align:center;" v-for="rate in field.values"
          v-show="!isValueHidden(rate.value)">
        <input class="form-radio" type="radio"
               :name="field.name" :data-vv-as="field.description.replace(/\./g, '')"
               :disabled="locked"
               v-validate="{required: required && !field.hide}"
               :value="rate.value"
               title="1"
               :id="field.name + '_' + field.value"
               @change="$emit('input', rate.value)"
        ></td>
      <td><label>{{ field.maxText }}</label></td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false,
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
    hiddenValues: {
      type: Array,
      default: false,
    }
  },

  emits: ['input'],

  setup(props) {
    // TODO: move to composable
    const isValueHidden = (value) => {
      if (props.hiddenValues) {
        return props.hiddenValues.some(h => {
          return h.field === props.field.name && value === h.value
        })
      }
      return false;
    }

    return {
      isValueHidden,
    }
  }
}
</script>

<style scoped lang="scss">
.rating td {
  padding: 4px 7px;
}

.rating th {
  padding: 0 5px;
}
</style>



// WEBPACK FOOTER //
// RatingRender.vue?4f85c5c9